import { Contact } from '@shared/models/contact/contact';
import { BasicUser, User, UserProfile } from '@shared/models/user';
import { LookupContactItem, LookupUserItem } from '@shared/types/common/common';

// Contact

export const listContactToLookupContact = (contact: Contact): LookupContactItem => ({
  id: contact.id,
  name: contact.name,
  company_name: contact.company?.name ?? null,
  email: contact.email,
  mobile_number: contact.mobile_number,
  phone_number: contact.phone_number,
});

// User

export const configUserToLookupUser = (user: UserProfile): LookupUserItem => ({
  id: user.id,
  image: user.image?.url ?? '',
  name: user.name,
  organisationName: user.organisation?.name ?? null,
  theme: user.theme,
});

export const listUserToLookupUser = (user: BasicUser | User): LookupUserItem => ({
  id: user.id,
  image: user.image?.url ?? '',
  name: user.name,
  organisationName: user.organisation?.name ?? null,
  theme: user.theme,
});
